import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-ZTCX702B75";
const GA_IDSDTI = "G-4F57ZZSN3E";

function Analytics() {

    const location = useLocation();

    useEffect(() => {

//         if (window.gtag) {

//             window.gtag("config", GA_ID, {
//                 page_path: location.pathname + location.search,
//             });
//             window.gtag("config", GA_IDSDTI, {
//                 page_path: location.pathname + location.search,
//             });

//         }

//     }, [location]);

//     return null;
// }

// Evitar duplicar el script si ya existe
    if (document.getElementById('google-analytics-script')) return;

    // 1. Crear e inyectar el script principal de Google Tag Manager
    const script = document.createElement('script');
    script.id = 'google-analytics-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    // 2. Inicializar eldataLayer y la función gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());

    // 3. Configurar ambos IDs
    gtag('config', GA_ID);
    gtag('config', GA_IDSDTI);
  }, []);

  return null; // Este componente no renderiza nada en la interfaz
};

export default Analytics;